var Raven

if (typeof history.pushState === 'function') {
  Raven = require('raven-js')
  Raven.config(gon.sentry_dsn).install()
}
